export const SAVE_REQUEST = Object.freeze({ timeout: 20 * 1000 });

export const SYNC_REQUEST = Object.freeze({ timeout: 60 * 1000 });
